// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-accordion {
  display: block;
  transition: margin-bottom 0.3s;
}
.app-accordion + .app-accordion {
  margin-top: 2rem;
}
.app-accordion.app-accordion_opened {
  margin-bottom: -6rem;
}
.app-accordion .app-accordion__header {
  height: 6rem;
  background: var(--white);
  padding: 0 2rem 0 3rem;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: box-shadow 0.3s;
  position: relative;
  z-index: 16;
}
.app-accordion .app-accordion__header:hover, .app-accordion .app-accordion__header.active {
  box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);
}
.app-accordion .app-accordion__header .app-accordion__title {
  font-size: 1.6rem;
  line-height: 1.9rem;
  font-weight: 500;
  letter-spacing: 0.005em;
  color: var(--black);
  margin-right: auto;
}
.app-accordion .app-accordion__header .app-accordion__required {
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--red);
}
.app-accordion .app-accordion__header .app-accordion__complete {
  display: flex;
  align-items: center;
}
.app-accordion .app-accordion__header .app-accordion__complete i {
  font-size: 2.4rem;
  color: var(--green);
  margin-right: 1rem;
}
.app-accordion .app-accordion__header .app-accordion__complete .app-accordion__text {
  font-size: 1.4rem;
  line-height: 1.7rem;
  color: var(--black);
}
.app-accordion .app-accordion__header .app-accordion__icon-arrow {
  font-size: 1.8rem;
  margin-left: 9rem;
  transition: transform 0.3s;
}
.app-accordion .app-accordion__header.active .icon-arrow {
  transform: rotateX(180deg);
}
.app-accordion .app-accordion__header.disabled {
  cursor: not-allowed;
}
.app-accordion .app-accordion__header.disabled .app-accordion__title {
  color: var(--grey-text);
}
.app-accordion .app-accordion__container {
  border-radius: 0.8rem;
  position: relative;
  top: -6rem;
}
.app-accordion .app-accordion__container .app-accordion__wrap {
  background: var(--white);
  padding: 9rem 3rem 5rem;
}
.app-accordion .app-accordion__container .app-accordion__wrap .app-accordion__content {
  background: var(--bg);
  padding: 2rem 2rem 5rem;
  border-radius: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/accordion/accordion.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,8BAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,oBAAA;AAAJ;AAGE;EACE,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;AADJ;AAGI;EAEE,gDAAA;AAFN;AAKI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAHN;AAMI;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;AAJN;AAOI;EACE,aAAA;EACA,mBAAA;AALN;AAOM;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AALR;AAQM;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;AANR;AAUI;EACE,iBAAA;EACA,iBAAA;EACA,0BAAA;AARN;AAYM;EACE,0BAAA;AAVR;AAeE;EACE,mBAAA;AAbJ;AAeI;EACE,uBAAA;AAbN;AAiBE;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;AAfJ;AAiBI;EACE,wBAAA;EACA,uBAAA;AAfN;AAiBM;EACE,qBAAA;EACA,uBAAA;EACA,qBAAA;AAfR","sourcesContent":[".app-accordion {\n  display: block;\n  transition: margin-bottom 0.3s;\n\n  & + & {\n    margin-top: 2rem;\n  }\n\n  &.app-accordion_opened {\n    margin-bottom: -6rem;\n  }\n\n  & .app-accordion__header {\n    height: 6rem;\n    background: var(--white);\n    padding: 0 2rem 0 3rem;\n    border-radius: 0.8rem;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: box-shadow 0.3s;\n    position: relative;\n    z-index: 16;\n\n    &:hover,\n    &.active {\n      box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);\n    }\n\n    & .app-accordion__title {\n      font-size: 1.6rem;\n      line-height: 1.9rem;\n      font-weight: 500;\n      letter-spacing: 0.005em;\n      color: var(--black);\n      margin-right: auto;\n    }\n\n    & .app-accordion__required {\n      font-size: 2rem;\n      line-height: 2.4rem;\n      color: var(--red);\n    }\n\n    & .app-accordion__complete {\n      display: flex;\n      align-items: center;\n\n      & i {\n        font-size: 2.4rem;\n        color: var(--green);\n        margin-right: 1rem;\n      }\n\n      & .app-accordion__text {\n        font-size: 1.4rem;\n        line-height: 1.7rem;\n        color: var(--black);\n      }\n    }\n\n    & .app-accordion__icon-arrow {\n      font-size: 1.8rem;\n      margin-left: 9rem;\n      transition: transform 0.3s;\n    }\n\n    &.active {\n      & .icon-arrow {\n        transform: rotateX(180deg);\n      }\n    }\n  }\n\n  & .app-accordion__header.disabled {\n    cursor: not-allowed;\n\n    .app-accordion__title {\n      color: var(--grey-text);\n    }\n  }\n\n  & .app-accordion__container {\n    border-radius: 0.8rem;\n    position: relative;\n    top: -6rem;\n\n    & .app-accordion__wrap {\n      background: var(--white);\n      padding: 9rem 3rem 5rem;\n\n      & .app-accordion__content {\n        background: var(--bg);\n        padding: 2rem 2rem 5rem;\n        border-radius: 0.8rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
